import React from 'react';

import Input from '@ott/input';
import { l10n } from '@ott/l10n';

import { dataLocators, fieldsNames } from '../../../constants';
import { transforms } from '../../../helpers';
import { useCreditCardContext } from '../../../provider';

import styles from './CardHolderInput.scss';

const { format, parse } = transforms[fieldsNames.cardHolder];

export const CardHolderInput = () => {
  const { touchField, checkIfFieldInvalid, changeFieldValue, cardToDisplay, isSavedCard } =
    useCreditCardContext();

  const hasError = checkIfFieldInvalid(fieldsNames.cardHolder);
  const handleBlur = () => touchField(fieldsNames.cardHolder);
  const handleCardHolderChange = (cardHolder: string) =>
    changeFieldValue(fieldsNames.cardHolder, cardHolder);

  return (
    <Input
      className={styles.cardHolder}
      label={l10n('paymentCardNew.namePlaceholder')}
      autoComplete="cc-name"
      parser={parse}
      formatter={format}
      name={fieldsNames.cardHolder}
      value={cardToDisplay[fieldsNames.cardHolder]}
      onChange={handleCardHolderChange}
      onBlur={handleBlur}
      hasError={hasError}
      isDisabled={isSavedCard}
      specificLocators={dataLocators.cardHolder}
    />
  );
};
